import { render, staticRenderFns } from "./contactUsUnit.vue?vue&type=template&id=5bf9487f&scoped=true"
import script from "./contactUsUnit.vue?vue&type=script&lang=js"
export * from "./contactUsUnit.vue?vue&type=script&lang=js"
import style0 from "./contactUsUnit.vue?vue&type=style&index=0&id=5bf9487f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9487f",
  null
  
)

export default component.exports